import { FC, PropsWithChildren, useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import styles from './index.module.sass'

interface Props {
  className?: string;
  fixed?: boolean;
  hideOnScroll?: boolean;
  isDisplay?: boolean;
}

const BottomBar: FC<PropsWithChildren<Props>> = ({
  className = '',
  isDisplay = true,
  hideOnScroll = true,
  fixed = true,
  children
}) => {
  const ref = useRef(null)
  const [hide, setHide] = useState(false)

  useEffect(() => {
    if (!fixed || !hideOnScroll) return

    let prevScrollpos = window.pageYOffset
    const scrollListener = () => {
      const contentHeight = ref.current?.getBoundingClientRect().height ?? 0
      const currentScrollPos = window.pageYOffset
      const nearTheBottom =
        window.innerHeight + currentScrollPos >= document.body.offsetHeight - contentHeight
      setHide(currentScrollPos > 0 && prevScrollpos < currentScrollPos && !nearTheBottom)
      prevScrollpos = currentScrollPos
    }
    window.addEventListener('scroll', scrollListener)
    return () => {
      window.removeEventListener('scroll', scrollListener)
    }
  }, [hideOnScroll, fixed])

  return isDisplay
    ? (
    <footer
      id="footer"
      className={clsx(
        styles.bottomBar,
        fixed ? styles.fixed : null,
        hide ? styles.hide : null
      )}
    >
      <div
        ref={ref}
        className={clsx(
          styles.bottomBarContent,
          className
        )}
      >
        {children}
      </div>
    </footer>
      )
    : null
}

export default BottomBar
